import { personQuery, catchErrorsV2, vesselQuery } from '../ReportsAPI';
import { populateLocations } from './helpers/person.helper';
import { getSelectedItems } from 'common/state.helper';

const initialState = {
    timelineData: null,
};

export const person = {
    name: 'person',
    state: initialState,

    reducers: {
        setPersonData(state, { timelineData }) {
            return { ...state, timelineData };
        },
    },

    effects: (dispatch) => ({
        async loadAll() {
            await catchErrorsV2(
                () => dispatch.person.getPersonData(),
                () => dispatch.person.setPersonData({ timelineData: null })
            );
        },

        async getPersonData(_, state) {
            const { selectedDate, selectedParkId } = getSelectedItems(state);
            const [personResponse, vesselResponse] = await Promise.all([
                personQuery(selectedDate, selectedParkId),
                vesselQuery(selectedDate, selectedParkId),
            ]);

            const { data } = personResponse;
            const { data: vesselData } = vesselResponse;

            // remove empty row entry from the chart
            const excludedTypes = ['SHORE', 'UNKNOWN'];
            const filteredPersonData = data.filter(({ location_type }) => !excludedTypes.includes(location_type));
            dispatch.person.setPersonData({
                timelineData: populateLocations(filteredPersonData, selectedDate, vesselData),
            });
        },
    }),
};

export default person;
